module.exports = __webpack_public_path__ + "img/BW.63351ba4.svg";